module.exports = __webpack_public_path__ + "img/Raw animal-based.beb98de4.png";